import styled from 'styled-components';

import { BasicParagraph, BiggerSubtitle, style } from '@genially/design-system';
import { SuccessIcon } from '@genially/icons';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(2),
  height: '100%',
}));

export const StyledBiggerSubtitle = styled(BiggerSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
  textAlign: 'center',
}));

export const EmptyText = styled(BasicParagraph)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
  textAlign: 'center',
}));

export const IconWrapper = styled.div(({ theme: { color, size } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  borderRadius: '100%',
  backgroundColor: color.background.success.default(),
  border: `2px solid ${color.border.primary.hover()}`,

  ...style.mixins.responsive.xs.downward({
    width: size.units(4),
    height: size.units(4),
  }),
}));

export const StyledSuccessIcon = styled(SuccessIcon)(({ theme: { color } }) => ({
  color: color.content.success.default(),
}));
